import { ref } from '@vue/composition-api'

const STORAGE_KEY = 'kitchen_hall_selected_ids'

function loadFromStorage() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)

    return stored ? JSON.parse(stored) : null
  } catch {
    return null
  }
}

// シングルトン: 全てのcomposable呼び出しで共有
// null = 全ホール表示（「すべて」）
const selectedHallIds = ref(loadFromStorage())

export default function useKitchenHallFilter() {
  function setSelectedHallIds(ids) {
    selectedHallIds.value = ids
    if (ids === null) {
      localStorage.removeItem(STORAGE_KEY)
    } else {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids))
    }
  }

  // null（すべて）のときは全ホールが選択扱い
  function isHallSelected(hallId) {
    if (selectedHallIds.value === null) return false

    return selectedHallIds.value.includes(String(hallId))
  }

  function isAllSelected() {
    return selectedHallIds.value === null
  }

  function toggleHall(hallId) {
    const id = String(hallId)

    if (selectedHallIds.value === null) {
      setSelectedHallIds([id])

      return
    }

    if (selectedHallIds.value.includes(id)) {
      const next = selectedHallIds.value.filter(hid => hid !== id)

      // 全て外したら「すべて」に戻す
      setSelectedHallIds(next.length === 0 ? null : next)
    } else {
      setSelectedHallIds([...selectedHallIds.value, id])
    }
  }

  function selectAll() {
    setSelectedHallIds(null)
  }

  // 絞り込み判定。hallIdが取れない注文（旧データ等）は常に表示する
  function matchesHallFilter(hallId) {
    if (selectedHallIds.value === null) return true
    if (hallId == null) return true

    return selectedHallIds.value.includes(String(hallId))
  }

  return {
    selectedHallIds,
    isHallSelected,
    isAllSelected,
    toggleHall,
    selectAll,
    matchesHallFilter,
  }
}
